import { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import ExistingGameList from '@/components/hub/ExistingGameList.js';
import { get, post } from '@/config/axiosConfig';
import { socket } from '@/socket';
import { GameContext } from '@/state/contexts';
import { logg } from '@/util/logg';
import { resumeGame } from '@lc/const/socketEvent';
import { createCurrPlayer } from '@lc/interface/currPlayer/factory';

import LyocTitle from '../static/LyocTitle';
// import { socketManager } from '@/SocketManager';

const MultiplayerLauncher = () => {
	const navigate = useNavigate();
	const {
		setEnableSocket,

		setUserId,
		// userId,

		setDefaultName,
		// defaultName,
		setDefaultColor,
		// defaultColor,

		setCurrPlayer,
		setGameId,
		// gameId,

		// setInitState,
		// setSinglePlayer,
		// setStateChangeHistory,
		// setStartGameBool,
	}: any = useContext(GameContext);

	const [gameList, setGameList] = useState([]);

	const [localGameId, setLocalGameId] = useState('');

	async function getUserMeta() {
		const response = await get('/username'); // GET PLAYER NAME && DEFAULT COLOR
		if (!response) {
			return;
		}
		logg('/username **');
		logg(response.data);
		setDefaultName(response.data.username);
		setDefaultColor(response.data.default_color);
		setUserId(response.data.user_id);

		// socketManager.init();
	}

	useEffect(() => {
		async function getExistingGameList() {
			const response = await get('/existing-games');
			if (response && response.data) {
				logg('loggin the lizzist');
				logg(response);
				logg(response.data);
				setGameList(response.data);
			}
		}

		getExistingGameList();
		getUserMeta();
		setEnableSocket(true);
	}, []);

	function joinLobby(gameId: string) {
		// socketManager.connect();
		socket.connect();
		navigate(`/lobby?gameId=${gameId}`, { replace: true });
	}

	// TODO HERE!! Nav to a SOCKETED LOBBY VIA THE URL, ATTACH TO ROOM
	// lol i legit forget how this exists. would be a good video
	async function navToNewLobby(e) {
		e.preventDefault();
		const response = await post('lobby');
		logg('response navToLobby');
		logg(response);

		if (response && response.data) {
			const gId = response.data.id;
			setGameId(gId);
			setLocalGameId(gId);
			joinLobby(gId);
		}
	}

	// TODO HERE!! Nav to a SOCKETED LOBBY VIA THE URL, ATTACH TO ROOM
	async function navToExistingLobby(e) {
		e.preventDefault();
		setGameId(localGameId);
		joinLobby(localGameId);
	}

	// TODO I need: Can all be retrieved via a rest call & set to hooks before nav to game:
	// 1) currPlayer
	// 2) players array
	// 3) game state
	// Also, a connection array to display who is in the game and who is connected or not would be chill
	// so, players in an array with their id, and a confirm or deny if connected or not
	async function navToExistingGame(e, gameId) {
		// GET ALL CURR PLAYER DATA AND STATE THEN NAV TO BOARD3D, OR GRAB STATE FROM QUERY?! OR MAKE THE CONTEXT AND A CONTEXT DECOUPLER
		e.preventDefault();
		// navigate(`/lobby?gameId=${lobbyId}&resume=true`, {replace: true});
		const res = await get(`curr-player/${gameId}`);

		if (res == null || res.data == null) {
			return;
		}
		const currPlayerObj = createCurrPlayer(
			res.data.color,
			res.data.player_id,
			res.data.game_id
		);

		setCurrPlayer(currPlayerObj);
		const gId = setGameId(res.data.game_id);
		// socket.join(res.data.game_id);
		socket.emit(resumeGame, currPlayerObj);
		navigate(`/board3d?gameId=${gameId}`, { replace: true }); //?gameId=${lobbyId}
	}

	return (
		<div className="titleContainer">
			<div className="login-form">
				<label>
					<p>Multiplayer</p>
				</label>
				<button onClick={(e) => navToNewLobby(e)}>
					Create Multiplayer Lobby
				</button>
				<form onSubmit={(e) => navToExistingLobby(e)}>
					<label>
						<p>Join Existing Lobby</p>
						<input
							type="text"
							onChange={(e) => setLocalGameId(e.target.value)}
							placeholder="Enter Lobby ID"
						/>
					</label>
					<div>
						<button type="submit">Join Multiplayer Lobby</button>
					</div>
				</form>
			</div>

			<div className="login-form">
				<p>Previous Multiplayer Games</p>
				<ExistingGameList
					gameList={gameList}
					navToExistingGame={navToExistingGame}
				/>
			</div>
		</div>
	);
};

export default MultiplayerLauncher;
